
// ROUTES
require('modules/feedback/routes/feedback');

// CONTROLLERS
require('modules/feedback/controllers/feedback');
require('modules/feedback/controllers/list');
require('modules/feedback/controllers/detail');

// SERVICES
require('modules/feedback/services/feedback');
require('modules/feedback/services/list');
require('modules/feedback/services/edit');
require('modules/feedback/services/delete');


angular.module('unica_feedback', [

	'infinite-scroll',
	'angular-confirm',
	'bootstrapLightbox',

	// ROUTES
	'unica_feedback.feedback_routes',

	// CONTROLLERS
	'unica_feedback.feedback_controllers',

	// SERVICES
	'unica_feedback.feedback_services'

]);